import { OrderStatusType } from 'api/types/entity';
import { ROUTES } from 'libs/navigation';
import { Title } from 'modules/account/common/components';
import { ChipOrderStatus } from 'modules/account/orderModule/common/components';

import { HeaderStyled } from './OrderHeader.styles';

export interface OrderHeaderProps {
  title: string;
  orderStatus?: OrderStatusType;
}

export const OrderHeader = ({ title, orderStatus }: OrderHeaderProps) => (
  <HeaderStyled>
    <Title backLink={ROUTES.account.orders.fullPath} title={title} />
    {orderStatus && (
      <ChipOrderStatus
        status={orderStatus}
        uppercase={false}
        variant="medium"
      />
    )}
  </HeaderStyled>
);
